import { Box, InputAdornment, TextField } from "@mui/material";
import { FC, useEffect } from "react";
import { InputProps } from "../types";
import WrongInput from "../../assets/Icons/WrongInput.svg";
import BootstrapTooltip from "../ToolTips/BootstrapTooltip";
import { useMediaQuery } from "@mui/material";
import { AlertPopupMobile } from "components/AlertPopupMobile";
import { useInputFieldStyles } from "./style";

const InputField: FC<InputProps> = ({
  onChange,
  value,
  placeholder,
  width,
  err,
  type,
  onKeyDown,
  autoFocus,
  customAdornment,
  className,
}) => {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const classes = useInputFieldStyles();

  return (
    <TextField
      fullWidth
      placeholder={placeholder}
      type={type}
      onKeyDown={onKeyDown}
      className={`${classes.default}  ${className}`}
      id="input"
      variant="outlined"
      onChange={onChange}
      value={value}
      autoFocus={autoFocus}
      sx={{
        "& input": {
          paddingTop: "0px",
          paddingBottom: "0px",
        },
      }}
      error={err ? true : false}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            {customAdornment || err ? (
              <>
                <Box sx={{ marginTop: "5px" }}>
                  {err &&
                    (isMobile ? null : (
                      <BootstrapTooltip title={err}>
                        <img src={WrongInput} />
                      </BootstrapTooltip>
                    ))}
                </Box>
                {!err && customAdornment}
              </>
            ) : null}
          </InputAdornment>
        ),
      }}
    />
  );
};

InputField.defaultProps = {
  width: "auto",
  autoFocus: false,
};

export default InputField;
